export default {
  custom: {
    email: {
      required: 'Please enter email address.',
      email: 'Please enter a valid email address.',
    },
    password: {
      required: 'Please enter your password.',
    },
    newpassword: {
      required: 'Please enter 6 character password.',
    },
    currentpassword: {
      required: 'Please enter your current password.',
    },
    confirmpassword: {
      required: 'Please confirm your password.',
    },
    firstname: {
      required: 'Please enter your First Name.',
    },
    lastname: {
      required: 'Please enter your Last Name.',
    },
    phone: {
      required: 'Please enter your Phone Number.',
    },
  },
};
